import React, { useEffect, useState } from 'react';
import { useStateContext } from '../../Contexts/ContextProvider';
import AxiosClient from '../../assets/AxiosClient';
import { Link } from 'react-router-dom';
import ConferencesRow from './ConferencesRow';
import Loader from '../../assets/tools/Loder/loader';
import { PageHeader } from '../../componants/Workspace';
import './Conferences.css';

const sectionOrder = ['live', 'upcoming', 'past'];
const sectionLabels = {
  live: 'Live',
  upcoming: 'Upcoming',
  past: 'Past',
};

const getConferenceStatus = (conference, now) => {
  const start = new Date(conference.start_date).getTime();
  const end = new Date(conference.end_date || conference.start_date).getTime();

  if (Number.isNaN(start) || Number.isNaN(end)) return 'past';
  if (now >= start && now <= end) return 'live';
  return now < start ? 'upcoming' : 'past';
};

const compareConferences = (status) => (first, second) => {
  const firstDate = new Date(status === 'past' ? first.end_date : first.start_date).getTime();
  const secondDate = new Date(status === 'past' ? second.end_date : second.start_date).getTime();
  return status === 'past' ? secondDate - firstDate : firstDate - secondDate;
};

const Conferences = () => {
  const [conferences, setConferences] = useState([]);
  const { SetNotification } = useStateContext();
  const [loading, setIsLoading] = useState(true);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await AxiosClient.get('/conferences');
        setConferences(response.data.conferences || []);
      } catch (error) {
        SetNotification('Error fetching data', 'danger');
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [SetNotification]);

  useEffect(() => {
    const interval = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(interval);
  }, []);

  const groupedConferences = conferences.reduce((groups, conference) => {
    const status = getConferenceStatus(conference, now);
    groups[status].push(conference);
    return groups;
  }, { live: [], upcoming: [], past: [] });

  sectionOrder.forEach((status) => groupedConferences[status].sort(compareConferences(status)));

  return (
    <>
      <PageHeader
        title="Conferences"
        description="Manage event details and conference schedules."
        actions={(
          <Link className="btn btn-primary" to="./Add">
            <i className="material-icons" aria-hidden="true">add</i>
            Add conference
          </Link>
        )}
      />
      {loading ? <div className="workspace-loading"><Loader label="Loading conferences..." /></div> : (
        <div className="conference-sections">
          {sectionOrder.map((status) => (
            <section className={`conference-section conference-section--${status}`} key={status}>
              <header className="conference-section__header">
                <div className="conference-section__title">
                  <span className="conference-section__indicator" aria-hidden="true" />
                  <h2>{sectionLabels[status]}</h2>
                </div>
                <span className="conference-section__count">{groupedConferences[status].length}</span>
              </header>
              {groupedConferences[status].length > 0 ? (
                <div className="conference-grid">
                  {groupedConferences[status].map((conference) => (
                    <ConferencesRow key={conference.id} conference={conference} status={status} now={now} />
                  ))}
                </div>
              ) : (
                <p className="conference-section__empty">No {sectionLabels[status].toLowerCase()} conferences.</p>
              )}
            </section>
          ))}
        </div>
      )}
    </>
  );
};

export default Conferences;